// Note: these cannot be destructured, as they are magically injected by nextjs
export const VERCEL_URL = process.env.NEXT_PUBLIC_URL_DOCS; // URL of deployment
